export default {"src":"/_next/static/media/BearsNotFound.16ee3d90.gif","height":1000,"width":1000};